export const RUNTIME = {
  WEB: 'Web',
  WEEX: 'Weex',
  UNKNOWN: 'Unknown'
}

export const PLATFORM = {
  MAC: 'Mac',
  WINDOWS: 'Windows',
  IOS: 'iOS',
  ANDROID: 'Android',
  IPAD: 'iPad',
  BROWSER:'Browser',
  UNKNOWN: 'Unknown'
}

export const FRAMEWORK = {
  VUE: 'Vue',
  RAX: 'Rax',
  UNKNOWN: 'Unknown'
};